// extracted by mini-css-extract-plugin
export var embla = "styles-module--embla--3d877";
export var emblaContainer = "styles-module--emblaContainer--2aa4a";
export var emblaSlide = "styles-module--emblaSlide--9b99f";